var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineSection1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 12,
    viewBox: "0 0 471 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 451,
    height: 4,
    transform: "matrix(-1 0 0 1 461 4)",
    fill: "#00B5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8Z",
    fill: "#00B5EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465 12C468.314 12 471 9.31371 471 6C471 2.68629 468.314 0 465 0C461.686 0 459 2.68629 459 6C459 9.31371 461.686 12 465 12ZM465 8C466.105 8 467 7.10457 467 6C467 4.89543 466.105 4 465 4C463.895 4 463 4.89543 463 6C463 7.10457 463.895 8 465 8Z",
    fill: "#00B5EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSection1);
export default __webpack_public_path__ + "static/media/line_section1.f69df2c1ceaf53097da604069334934b.svg";
export { ForwardRef as ReactComponent };